import { useTranslations } from '@vocab/react';
import { Heading, Stack, Text } from 'braid-design-system';

import { ContactUs } from 'src/app/shared/components/ContactUs';
import { Faqs } from 'src/app/shared/components/Faqs';

import translations from './.vocab';

export const FooterSection = () => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="xlarge">
      <Stack space="xlarge">
        <Stack space="medium">
          <Heading level="3">{t('faq-heading')}</Heading>
          <Text tone="secondary">{t('faq-subheading')}</Text>
        </Stack>
        <Faqs />
      </Stack>
      <ContactUs />
    </Stack>
  );
};
